import { ISession } from 'interfaces/session/ISession';
import { BallFinalKinds, IBallFinal } from '@trackman/baseball-shared-components';

export const findTeamInSession = (teamName: string, session: ISession) => {
  if (session.homeTeam.shortName.toLowerCase() === teamName.toLowerCase()) {
    return session.homeTeam;
  }
  if (session.awayTeam.shortName.toLowerCase() === teamName.toLowerCase()) {
    return session.awayTeam;
  }
  return undefined;
};

export const serializeValue = (val: any) => {
  if (val === null || val === undefined) {
    return '';
  }
  if (typeof val === 'object') {
    return JSON.stringify(val);
  }
  return val.toString();
};

export const getBallFinalTrackId = (ballFinals: IBallFinal[], kind: BallFinalKinds) => {
  const ballFinal = ballFinals.find((bf) => bf.kind === kind);
  return ballFinal ? ballFinal.trackId : undefined;
};
